// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"451":"ed1338d3","453":"9b2a0d66"}[chunkId] + ".chunk.js";
};